import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Avatar } from "@mui/material";
import Flex from "../../../../../components/Flex";
import { formatDate, formatTime } from "../../../../../utils/date-time-utility";
import Text from "../../../../../components/Text";
import {
  getInitials,
  getLightBgColor,
  replaceUnderScoreAddSpace,
} from "../../../../../utils/utils";

interface ChatUserProps {
  recentUnreadMsg?: number;
  message?: string;
  name: string;
  lastOnline?: string;
  bgcolor?: string;
  gender?: string;
  dob?: string;
}

export const ChatUser = ({
  recentUnreadMsg,
  message,
  name,
  lastOnline,
  gender,
  dob,
  bgcolor,
}: ChatUserProps) => {
  const colors = getLightBgColor(name);

  return (
    <Flex gap={2} width={"100%"} alignItems={"center"} px={1}>
      <Avatar
        sx={{
          bgcolor: bgcolor || colors.bg,
          color: colors.text,
          padding: "1.2rem",
          fontSize: "1rem",
        }}
      >
        {getInitials(name)}
      </Avatar>
      <Flex flexDirection={"column"} width={"100%"}>
        <Flex flexDirection={"column"} width={"100%"} alignItems={"start"}>
          <Flex justifyContent={"space-between"} width={"100%"}>
            <Flex
              gap={1}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Text fontWeight={"500"} color={"text.primary"}>
                {name}
              </Text>
              <Text fontWeight={"500"} color={"text.primary"}>
                {getSubData(gender, dob)}
              </Text>
            </Flex>
            <Text fontSize={"12px"} color={"text.secondary"}>
              {lastOnline ? formatTime(lastOnline) : ""}
            </Text>
          </Flex>
        </Flex>
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          {/* {message && <RenderWithTooltip value={message} />} */}
          <Text color={"text.secondary"}>
            {message && message?.length >= 30
              ? message?.slice(0, 30) + "..."
              : message}
          </Text>
          {!!recentUnreadMsg && (
            <Flex gap={0.5} alignItems={"center"} sx={{ mr: 0.5 }}>
              <ChatBubbleOutlineIcon
                sx={{ fontSize: 18, color: "text.secondary" }}
              />
              <Text fontSize={"11px"} fontWeight={600} color={"primary.main"}>
                {recentUnreadMsg}
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

const getSubData = (gender?: string, dob?: string) => {
  if (!gender && !dob) return;

  return `${gender ? replaceUnderScoreAddSpace(gender.toLowerCase())?.slice(0, 1) : ""} ${dob ? `| ${formatDate(dob)}` : ""}`;
};
